import {Recurrence} from "../domain/Recurrence";
import {Transaction} from "../domain/Transaction";
import {getCurrentMonth} from "../utils/getCurrentMonth";
import {generateRecurrenceTransactions} from "./generateRecurrenceTransactions";

export const generateRecurrencesTransactions = (
  recurrences: Recurrence[],
  existingTransactions: Transaction[],
  now: [number, number] = getCurrentMonth(),
): Transaction[] => {
  let recurringTransactions: Transaction[] = []
  recurrences.forEach(recurrence => {
    recurringTransactions = [...recurringTransactions, ...generateRecurrenceTransactions(recurrence, existingTransactions, now)]
  })
  return recurringTransactions
}
